import { useActIndicatorModel } from '@/components/home/components/act-indicator/act-indicator.model'
import { ActIndicatorView } from '@/components/home/components/act-indicator/act-indicator.view'

export function ActIndicatorViewModel() {
  const model = useActIndicatorModel()
  return <ActIndicatorView {...model} />
}
